<template>
  <FieldInput
    :value="value"
    :state="state"
    :placeholder="placeholder"
    type="text"
    :mask="mask"
    :on-blur="handleChange"
    :disabled="disabled"
    v-model="datetime"
    class-name="fieldDatetime"
    :style="fieldStyle"
    :bg-color="bgColor"
    :input-class="inputClass"
    :rules="[validateDateTime]"
    ref="inputRef"
  >
    <template #prepend>
      <q-icon
        size="xs"
        name="mdi-calendar"
        class="cursor-pointer q-mt-xs"
      >
        <q-popup-proxy
          transition-show="scale"
          transition-hide="scale"
        >
          <q-date
            v-model="datetime"
            mask="DD/MM/YYYY HH:mm"
          >
            <div class="row items-center justify-end">
              <q-btn
                v-close-popup
                label="Fechar"
                color="primary"
                flat
              />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>

    <template #append>
      <q-icon
        size="xs"
        name="mdi-clock-outline"
        class="cursor-pointer q-mt-xs"
      >
        <q-popup-proxy
          transition-show="scale"
          transition-hide="scale"
        >
          <q-time
            v-model="datetime"
            mask="DD/MM/YYYY HH:mm"
            format24h
          >
            <div class="row items-center justify-end">
              <q-btn
                v-close-popup
                label="Fechar"
                color="primary"
                flat
              />
            </div>
          </q-time>
        </q-popup-proxy>
      </q-icon>
    </template>
  </FieldInput>
</template>

<script>
import moment from 'moment-timezone'
import FieldInput from '@/components/FieldInput'

const ptBrFormat = 'DD/MM/YYYY HH:mm'

export default {
  components: {
    FieldInput
  },

  props: {
    value: {
      type: Number
    },

    state: {
      type: Object
    },

    label: {
      type: String
    },

    placeholder: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    maxlength: {
      type: Number,
      default: 255
    },

    fieldStyle: {
      type: String
    },

    bgColor: {
      type: String
    },

    inputClass: {
      type: String,
      default: 'backgroundColor: #f2f2f2'
    },

    rules: {}
  },

  data () {
    const datetime = this.value

      ? moment.unix(this.value).format(ptBrFormat)
      : ''

    return {
      mask: '##/##/#### ##:##',
      datetime
    }
  },

  methods: {
    handleChange () {
      const mDate = moment(this.datetime, ptBrFormat)
      const isValid = this.datetime && mDate.isValid()
      if (!isValid) this.datetime = ''
      this.$emit('input', isValid ? mDate.unix() : null)
    },

    validateDateTime (val) {
      if (!val) return true

      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/
      const match = val.match(regex)

      if (!match) {
        this.$emit('validate', false)
        return 'formato inválido'
      }

      const [, day, month, year, hour, minute] = match.map(Number)

      const isValidDate = (y, m, d) => {
        const date = new Date()
        return y >= date.getFullYear() && m - 1 >= date.getMonth()
      }

      const isValidTime = (h, m) => h >= 0 && h < 24 && m >= 0 && m < 60

      if (!isValidDate(year, month, day)) {
        this.$emit('validate', false)
        return 'data inválida'
      }
      if (!isValidTime(hour, minute)) {
        this.$emit('validate', false)
        return 'tempo inválido'
      }
      this.$emit('validate', true)
      return true
    }
  },
  watch: {
    datetime (val) {
      this.handleChange()
    }
  }
}
</script>
<style lang="sass">
  .fieldDatetime
    .q-field__control.relative-position
      padding-left: 3px
      padding-right: 3x
      border-radius: 2px

    .q-field__bottom
      background-color: #F2F2F2
</style>
